import { useEffect, useState } from "react";
import api from "@/lib/api";

export const ASSIGN_ROLES = ["counselor", "senior_counselor", "telecaller", "team_lead"];
export const assignable = (users) => users.filter((u) => u.active !== false && ASSIGN_ROLES.includes(u.role));
export const assigneeLabel = (u) => (u.role === "team_lead" ? `${u.name} \u2014 Team Lead` : u.team_lead_name ? `${u.name} (TL: ${u.team_lead_name})` : u.name);

let cache = null;
// id -> user (cached per page load) so tables can show the assignee's team lead
export function useUserMap() {
  const [map, setMap] = useState({});
  useEffect(() => {
    if (!cache) cache = api.get("/users").then(({ data }) => Object.fromEntries(data.map((u) => [u.id, u]))).catch(() => { cache = null; return {}; });
    cache.then(setMap);
  }, []);
  return map;
}

export function AssigneeCell({ id, name, map, empty = "Pool" }) {
  if (!name) return <span className="text-slate-400">{empty}</span>;
  const u = map[id];
  return (
    <div className="leading-tight">
      <div>{name}</div>
      {u?.role === "team_lead" ? <div className="text-[10px] font-semibold text-orange-600">Team Lead</div>
        : u?.team_lead_name ? <div className="text-[10px] text-slate-400" data-testid={`assignee-tl-${id}`}>TL: {u.team_lead_name}</div> : null}
    </div>
  );
}
